import handleReportSelectChange from './handle-report-select-change'

export default () => handleReportSelectChange()
